import axiosClient from './axiosClient';

export const adsService = {
  /**
   * Fetch ad slot configs (leaderboard, infeed, incontent, ...)
   * @param {boolean} activeOnly - Only return enabled slots
   */
  getAds: async (activeOnly = true) => {
    const response = await axiosClient.get('/api/ads', {
      params: { active_only: activeOnly },
    });
    return response.data;
  },
};

export default adsService;
